export default {
  data() {
    return {
      rowOptions: {
        'Total Income': {
          editable: true,
          format: 'currency',
        },
        'Taxable Income': {
          editable: true,
          format: 'currency',
        },
        'Total Tax Paid': {
          editable: true,
          format: 'currency',
        },
        'Total Tax Owed': {
          editable: true,
          format: 'currency',
        },
        'Amount Refunded': {
          editable: true,
          format: 'currency',
          cssClass: 'amount-refunded',
        },
        'Amount Owed': {
          editable: true,
          format: 'currency',
          cssClass: 'amount-owed',
        },
      },
    };
  },

  methods: {
    createNewTaxDetail(title = 'Other State Taxes') {
      const taxDetail = {
        title: title,
        rows: [
          { label: 'Amount Refunded', value: 0 },
          { label: 'Amount Owed', value: 0 },
        ],
      };

      return taxDetail;
    },

    parseCurrency(strValue) {
      if (typeof strValue !== 'string' || !strValue) {
        return 0;
      }
      const cleanedStr = strValue.replace(/\$|,/g, '');
      const num = parseFloat(cleanedStr);
      return isNaN(num) ? 0 : num;
    },

    formatCurrency(numValue) {
      const num = Number(numValue);
      if (isNaN(num)) {
        return '$0';
      }
      return num.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    formatPercentage(numValue) {
      const num = Number(numValue);
      if (isNaN(num)) {
        return '0%';
      }
      return `${Math.round(num)}%`;
    },

    recalculateTax(detail) {
      const paid = detail.rows.find(d => d.label === 'Total Tax Paid').value;
      const owed = detail.rows.find(d => d.label === 'Total Tax Owed').value;
      const taxableIncome = detail.rows.find(d => d.label === 'Taxable Income')
        .value;

      const difference = paid - owed;
      let effectiveRate = 0;
      if (taxableIncome !== 0) {
        effectiveRate = (owed / taxableIncome) * 100;
      }

      detail.rows.forEach(row => {
        if (row.label === 'Amount Refunded') {
          row.value = difference > 0 ? difference : 0;
        } else if (row.label === 'Amount Owed') {
          row.value = difference < 0 ? -difference : 0;
        } else if (row.label === 'Effective Rate') {
          row.value = effectiveRate;
        }
      });
    },

    shouldUseValueFromFederalTaxes(currentTaxDetailTitle, row) {
      return (
        this.canUseValueFromFederalTaxes(currentTaxDetailTitle, row) &&
        row.use_federal_taxes_value
      );
    },

    canUseValueFromFederalTaxes(currentTaxDetailTitle, row) {
      return (
        !currentTaxDetailTitle.startsWith('Federal') &&
        typeof row.use_federal_taxes_value === 'boolean'
      );
    },

    getValueFromFederalTaxes(rowLabel) {
      const federalTaxDetail = this.currentTaxDetails.find(detail =>
        detail.title.startsWith('Federal'),
      );

      const federalTotalIncomeRow = federalTaxDetail
        ? federalTaxDetail.rows.find(r => r.label === rowLabel)
        : null;

      return federalTotalIncomeRow ? federalTotalIncomeRow.value : 0;
    },

    getTrueValue(taxDetailName, row) {
      let rowValue = row.value;

      if (this.shouldUseValueFromFederalTaxes(taxDetailName, row)) {
        rowValue = this.getValueFromFederalTaxes(row.label);
      }

      return this.rowOptions[row.label].format === 'currency'
        ? this.formatCurrency(rowValue)
        : this.rowOptions[row.label].format === 'percentage'
        ? this.formatPercentage(rowValue)
        : rowValue;
    },

    getDisclaimerText(title, rowLabel) {
      if (title.startsWith('Federal')) {
        if (rowLabel === 'Amount Refunded') {
          return 'Note: This is the portion of your federal overpayment you elected to receive as a refund. It may reflect the estimated tax underpayment penalty (if any) and excludes any amount applied to next year’s estimated tax.';
        } else if (rowLabel === 'Amount Owed') {
          return 'Note: This is the remaining federal tax balance after payments and credits. It may include the estimated tax underpayment penalty (if any) and excludes late fees or interest — refer to your payment voucher for the full amount due.';
        }
      } else {
        if (rowLabel === 'Amount Refunded') {
          return 'Note: The refund shown here may include penalties or interest and may or may not include overpayments applied to next year, depending on the state.';
        } else if (rowLabel === 'Amount Owed') {
          return 'Note: The balance due here may or may not include penalties and interest — check your state payment voucher for the exact total.';
        }
      }
    },
  },
};
